import { textForHtmlEmail } from "encamp-shared/dist/utils/htmlTypeSafety";
import { BaseTemplate } from "../baseTemplate";
import { shortReportingYear, subjectForList, SIGNATURE, getReportingYear } from "./shared";
const NNR_RAW_TEMPLATE_PLACEHOLDER = "Newly-not-reporting cover letter (content from template).";
/**
 * Abstract base for newly-not-reporting cover letter templates.
 *
 * Produces both plain text (for PDF cover letters) and HTML (for email sending).
 * The html() output is derived from text() via textForHtmlEmail (newline → br).
 */
export class BaseNewlyNotReportingTemplate extends BaseTemplate {
    html(params) {
        return textForHtmlEmail(this.text(params));
    }
    toTemplate() {
        return {
            id: this.id,
            subject: this.subject.bind(this),
            text: this.text.bind(this),
            html: this.html.bind(this),
            rawTemplate: () => NNR_RAW_TEMPLATE_PLACEHOLDER,
            extractVariables: () => ({}),
        };
    }
    shortReportingYear(year) {
        return shortReportingYear(year);
    }
    subjectForList(organizationName, reportingYear) {
        return subjectForList(organizationName, reportingYear);
    }
    get signature() {
        return SIGNATURE;
    }
    buildSubject(communication) {
        return this.subjectForList(communication.tenant.name, getReportingYear(communication));
    }
}
//# sourceMappingURL=baseNewlyNotReportingTemplate.js.map